<template>
  <div>
    <div class="listing-type-one d-xl-flex flex-wrap justify-content-between">
      <div
        class="showing-div align-self-center"
        style="font-size: 24px; font-weight: bold;"
      >
        <span>{{ reviewListTitle }}</span>
      </div>
      <!-- <div
        class="showing-div align-self-center"
        v-if="applicantCounts.total != 0"
      >
        {{ applicantCounts.from }}-{{ applicantCounts.to }}名表示 /
        {{ applicantCounts.total }}名登録
      </div> -->
    </div>
    <!-- ends listing-type-one -->
  </div>
</template>

<script>
import Favorite from '@/components/dashboard/applicants/Favorite.vue';
import mutations from '@/config/mutations';
import { mapState, mapMutations, mapGetters } from 'vuex';

export default {
  name: 'SearchBar',
  components: {
    Favorite,
    // Csv,
  },
  props: ['review_list_id'],
  data() {
    return {
      class1:
        'one-left d-xl-flex align-items-center justify-content-center justify-content-md-start',
      // sortingItems: {
      //   'activity.created_at': '登録日',
      //   last_year_income: '年収',
      //   full_name: '名前',
      // },
      title: '',
      isDefault: 'no',
      errors: {
        title: {
          error: false,
          msg: '',
        },
      },
    };
  },
  computed: {
    ...mapState({
      favoritesOnly: ({ applicant }) => applicant.favoritesOnly,
      sortBy: ({ applicant }) => applicant.sortBy,
      searchParams: ({ applicant }) => applicant.searchParams,
    }),
    ...mapGetters({
      applicantCounts: 'getApplicantCounts',
      reviewLists: 'getReviewLists',
    }),
    reviewListTitle() {
      if (!this.reviewLists || this.reviewLists.length === 0) {
        return ''; // or return a default value
      }
      let reviewList = this.reviewLists.find(
        (item) => item._id == this.$route.params.id
      );
      return reviewList.title;
    },
    isNoSearch() {
      return Object.keys(this.searchParams).length === 0 && this.sortBy === '';
    },
    titleState() {
      return this.title.length > 2;
    },
  },
  methods: {
    ...mapMutations([mutations.applicant.TOGGLE_FAVORITES]),
    toggleFavoriteApplicants() {
      this[mutations.applicant.TOGGLE_FAVORITES](!this.favoritesOnly);
    },
  },
  watch: {
    title(value) {
      if (value === '') {
        this.errors.title.error = true;
        this.errors.title.msg = '検索条件名は必須項目です';
      } else {
        this.errors.title.error = false;
        this.errors.title.msg = '';
      }
    },
  },
};
</script>
<style scoped>
.btn-clear {
  background-color: #f0f5f7;
  border-color: #f0f5f7;
  color: #89969f !important;
}

.btn-clear:hover,
.btn-clear:focus {
  background-color: #dae0e2 !important;
  border-color: #dae0e2 !important;
}
.one-right .btn-heart:hover i {
  color: #aba2a2;
}
</style>
